import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import logo from '../../assets/logo.png';
import foto from '../../assets/fotolanding.jpg';
import { Destello } from '../publico/Iconos';
import './Inicio.css';

/** Pantalla de bienvenida del SUPER_ADMIN (/inicio), con la misma identidad de la landing. */
const Inicio = () => {
    const { user } = useContext(AuthContext);
    const nombre = user?.first_name || user?.username || '';

    return (
        <div className="in">
            <div className="in-text">
                <img src={logo} alt="frè Choco Lab" className="in-logo" />
                <h1 className="in-title">
                    Bienvenido a <span className="in-accent">frè</span>
                </h1>
                {nombre && <p className="in-hello">Hola, {nombre}.</p>}
                <p className="in-lead">Selecciona una opción del menú lateral para comenzar a administrar tu negocio.</p>
            </div>

            <div className="in-photo">
                <div className="in-frame-wrap">
                    <div className="in-frame" style={{ backgroundImage: `url(${foto})` }} role="img"
                        aria-label="Postres de fresa y crema de frè Choco Lab" />
                </div>
                <Destello className="in-spark in-spark-1" size={24} />
                <Destello className="in-spark in-spark-2" size={14} />
            </div>
        </div>
    );
};

export default Inicio;
